import { useMemo } from 'react';
import { User, canManageAttributes, isSuperAdmin } from '../../types/permissions';

interface FarmData {
  farm: any;
  actions: any[];
}

export const useFarmPermissions = (
  user: User | any,
  userActions: string[] | any,
  farmData: FarmData | null,
  farmId?: string,
) => {
  const canManageFarmAttributes = useMemo(() => {
    if (!user) return false;
    
    // Проверка глобальных прав суперадминистратора
    if (isSuperAdmin(user)) {
      return true;
    }
    
    // CN-0008: Новая структура прав
    if (user.actions && typeof user.actions === 'object' && 'global' in user.actions) {
      return canManageAttributes(user, farmId);
    }
    
    // Старая структура прав (для обратной совместимости)
    if (Array.isArray(userActions)) {
      const hasGlobalPermission = 
        userActions.includes('crop_attributes.manage') ||
        userActions.includes('crops.attributes.manage') ||
        userActions.includes('crops.attributes.update');
      if (hasGlobalPermission) return true;
    }
    
    // Проверка прав на уровне фермы - только если данные фермы загружены и это правильная ферма
    if (farmData?.farm && String(farmData.farm.id) === farmId) {
      if (farmData.farm.is_owner) {
        return true;
      }
      
      const farmActions = farmData.actions ?? [];
      if (Array.isArray(farmActions)) {
        const hasFarmPermission = 
          farmActions.some((action: any) => {
            const code = typeof action === 'string' ? action : action.code;
            return (
              code === 'crop_attributes.manage' ||
              code === 'crops.attributes.manage' ||
              code === 'crops.attributes.update' ||
              code === 'farms.update'
            );
          });
        if (hasFarmPermission) return true;
      }
    }
    
    return false;
  }, [user, userActions, farmData, farmId]);

  return { canManageFarmAttributes };
};
